<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <div class="grid-content">
          <h2>第2维护通道</h2>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="8">
        <div class="grid-content">
          <!-- <el-tag size="medium" class="tag" type="primary" style="width:80px;"
            >云平台</el-tag
          >
          <label for="cloud" style="margin:5px 0px;margin-right:20px;">{{
            cloud
          }}</label>
          <el-tag size="medium" class="tag" type="primary">MAC地址</el-tag>
          <label for="mac" style="margin:5px 0px;margin-right:20px;">{{
            mac
          }}</label> -->

          <el-tag
            size="medium"
            class="tag"
            type="primary"
            style="height:40px;margin-right:10px;"
            >MAC地址</el-tag
          >
          <el-autocomplete
            style="width:170px; margin-right:10px;"
            v-model="mac"
            :fetch-suggestions="querymacSearch"
            placeholder="MAC地址"
          ></el-autocomplete>
        </div>
      </el-col>

      <el-col :span="16">
        <div class="grid-content">
          <el-tag
            type="danger"
            style="font-size:14px;font-weight:bold;height:40px;line-height:40px;margin-right:10px"
            >第2维护通道批量操作:</el-tag
          >

          <el-tooltip placement="top" :hide-after="3000">
            <div slot="content">可以改文件名，但文件格式必须是 xlsx</div>
            <el-button
              @click="downloadFile"
              type="info"
              class="el-icon-download"
              size="medium"
              style="height:40px;margin-right:10px"
              >下载 Excel 模板</el-button
            >
          </el-tooltip>

          <el-upload
            size="medium"
            style="display:inline-block;height:40px;margin-right:10px"
            ref="upload"
            :action="uploadUrl()"
            :multiple="false"
            :limit="1"
            :on-preview="handlePreview"
            :on-remove="handleRemove"
            :on-success="handleUploadSuccess"
            :file-list="fileList"
            :auto-upload="false"
            :headers="config"
          >
            <el-button
              slot="trigger"
              size="medium"
              type="info"
              style="height:40px;margin-right:10px"
              >选取文件</el-button
            >
            <el-button
              style="height:40px;margin-right:10px"
              size="medium"
              type="info"
              @click="submitUpload"
              >上传到服务器</el-button
            >
          </el-upload>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="10">
        <div class="grid-content">
          <el-button @click="secOption('0')" type="primary">重启设备</el-button>
          <el-button @click="secOption('1')" type="primary"
            >重启dclient</el-button
          >
          <el-button @click="secOption('2')" type="primary"
            >恢复出厂设置</el-button
          >
          <el-button @click="secOption('3')" type="primary"
            >关闭告警通道</el-button
          >
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="grid-content">
          <el-button
            @click="secOption('4')"
            type="primary"
            style="vertical-align:middle"
            >autop 配置</el-button
          >
          <el-input
            style="width:81%; margin-left: 15px;vertical-align:middle"
            type="textarea"
            :rows="3"
            placeholder="请输入第2维护通道的配置项参数，每个配置项一行"
            v-model="autopParam"
          ></el-input>
        </div>
      </el-col>
    </el-row>

    <el-row :gutter="20">
      <el-col :span="24">
        <div class="grid-content">
          <el-button
            @click="secOption('5')"
            type="primary"
            style="vertical-align:middle"
            >修改保活时间</el-button
          >
          <el-input
            style="width:80%;margin-left: 15px;vertical-align:middle"
            type="textarea"
            :rows="3"
            placeholder="请输入保活时间（单位：秒）"
            v-model="timeParam"
          ></el-input>
        </div>
      </el-col>
    </el-row>

    <List
      url="maintenance/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :update="updateList"
      :MultipleSel="true"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Fresh" style="float:right;">
        <el-input
          v-model="searchData.mac"
          size="small"
          style="width:200px;margin-right:15px;"
          placeholder="请输入MAC地址"
        ></el-input>
        <el-button
          @click="updateList++"
          type="primary"
          size="small"
          style="margin-right:5px;"
          >Search</el-button
        >
      </div>
    </List>
    <UpdateBox
      :initForm="updateForm"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
    ></UpdateBox>
  </div>
</template>
<script>
import List from "../components/common/List.vue";
import { channelsList } from "../components/Index/data.js";
import UpdateBox from "../components/SecondChannel/UpdateBox.vue";

export default {
  components: {
    List,
    UpdateBox
  },
  data() {
    return {
      tanle: [
        { name: "mac", label: "MAC地址" },
        { name: "cmd", label: "命令" },
        { name: "param", label: "命令参数" },
        { name: "create_time", label: "创建时间" }
      ],
      searchData: {
        mac: ""
      },
      opions: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],
      mac: "",
      cloud: "",
      cmdtypes: ["console", "config", "keepalive"],
      cmds: [],
      updateList: 0,
      autopParam: "",
      timeParam: "",
      updateForm: {},
      updateBlock: false,
      channelsList: channelsList,
      title: "第2维护通道操作列表",
      token: "",
      fileList: []
    };
  },
  mounted() {
    this.mac = this.$route.query.mac;
    this.cloud = this.$route.query.cloud;
    this.token = localStorage.getItem("token");
  },
  methods: {
    dealList(data) {
      for (let i in data) {
        data[i].create_time = this.changeDate(data[i].create_time);
      }
      return data;
    },
    secOption(value) {
      var channel = this.channelsList[value];
      if (value === "4") {
        channel.Param = this.autopParam;
      }
      if (value === "5") {
        channel.Param = this.timeParam;
      }
      this.$http["post"](
        "maintenance/",
        {
          mac: this.mac,
          cloud: this.cloud,
          cmd: channel.Cmd,
          param: channel.Param
        },
        () => {
          this.updateList++;
          this.$baseNotice.message("执行成功");
        }
      );
    },
    edit(val) {
      this.updateBlock = true;
      this.updateForm = Object.assign({}, val);
    },
    close() {
      this.updateBlock = false;
    },
    deletedata(val) {
      let url = "maintenance/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    },
    //queryString 为在框中输入的值
    querymacSearch(queryString, cb) {
      // 调用 callback 返回建议列表的数据
      const macRecords = JSON.parse(localStorage.getItem("macRecord"));
      const results = queryString
        ? macRecords.filter(this.createmacFilter(queryString))
        : macRecords;
      cb(results);
    },
    createmacFilter(queryString) {
      return macRecord => {
        return (
          macRecord.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
        );
      };
    },
    downloadFile() {
      this.$http.http.defaults.responseType = "blob";
      this.$http.get("maintenance/file-batch/", {}, res => {
        let blob = new Blob([res], {
          type:
            "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        });

        let eLink = document.createElement("a");
        eLink.download = "batch_second_channel.xlsx";
        eLink.style.display = "none";
        eLink.href = URL.createObjectURL(blob);
        document.body.appendChild(eLink);
        eLink.click();
        URL.revokeObjectURL(eLink.href);
        document.body.removeChild(eLink);
      });
      this.$http.http.defaults.responseType = "json";
    },
    uploadUrl() {
      return this.$http.host + "maintenance/file-batch/";
    },
    submitUpload() {
      this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePreview(file) {
      console.log(file);
    },
    handleUploadSuccess(res, file, fileList) {
      console.log(file, fileList);
      let messageType = "success";
      if (res.code === 201) {
        messageType = "success";
      } else {
        messageType = "error";
      }
      this.$message({ type: messageType, message: res.msg });
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
</style>
